import React, { useEffect, useState } from "react";
import { Box } from "../../../../../designSystem";
import { get } from "../../../../../lib/api";
import { GenreAgeText, ListDiv, VoiceItem, VoiceNameText } from "./styles";
import genreImg from './genre.svg'
import Loader from "../../../../../components/Loader";
const BrowseList = ({ updateGenreSelected, isBackgroundMusic }) => {
    const [genreList, setGenreList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        setIsLoading(true)
        const api = isBackgroundMusic ? `/content_api/ugc/audio/supported_genres/?is_background=1`  : '/content_api/ugc/audio/supported_genres/'
        get(api).then((res) => {
            setGenreList(res)
            setIsLoading(false)
        }).catch((err) => setIsLoading(false))
    },[]) 
    return(
        <ListDiv>
            {isLoading ? <Loader /> : <ul>
                {genreList?.map((genre) => (
                    <li key={genre}>
                        <VoiceItem>
                            <Box>
                                <img src={genreImg} width={44} height={44}/>
                            </Box>
                            <Box ml={16} variant="flex" width="100%" alignItems="center">
                                <Box>
                                    <VoiceNameText>{genre.split('_').join(' ')}</VoiceNameText>
                                </Box>
                                <Box>
                                    <GenreAgeText style={{ cursor: 'pointer'}} onClick={() => updateGenreSelected(genre)}>See more</GenreAgeText>
                                </Box>
                            </Box>
                        </VoiceItem>
                    </li>
                ))}
            </ul>}
        </ListDiv>
    )
}

export default BrowseList